module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_1250-Red-b47c6ef59ab5398ad74af6fb9c4e57df.png";